"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardCommand = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = require("react");
var uuid_1 = require("uuid");
var DashboardEventsContext_1 = require("./DashboardEventsContext");
var DashboardStoreProvider_1 = require("./DashboardStoreProvider");
/**
 * Hook that takes command creator and event handlers and returns function
 * that will result into dispatching this command, registering the event handlers,
 * and unregistering them once event type with the same type and correlation ID is triggered.
 *
 * @remarks
 * If no correlationId is provided, it's auto-generated.

 * @param commandCreator - command factory
 * @param eventHandlers - record with eventTypes as keys and relevant callbacks as values
 * @param onBeforeRun - provide callback that will be called before dispatching the command
 * @returns callback that dispatches the command, registers relevant event handlers and unregisters them
 *          when an event that matches the correlation ID and one of the specified event types occurs
 * @internal
 */
exports.useDashboardCommand = function (commandCreator, eventHandlers, onBeforeRun) {
    var dispatch = DashboardStoreProvider_1.useDashboardDispatch();
    var _a = DashboardEventsContext_1.useDashboardEventsContext(), registerHandler = _a.registerHandler, unregisterHandler = _a.unregisterHandler;
    return react_1.useCallback(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var command = commandCreator.apply(void 0, tslib_1.__spread(args));
        var correlationId = (_a = command.correlationId) !== null && _a !== void 0 ? _a : uuid_1.v4();
        if (!command.correlationId) {
            command = tslib_1.__assign(tslib_1.__assign({}, command), { correlationId: correlationId });
        }
        var dashboardEventHandlers = eventHandlers
            ? Object.keys(eventHandlers).map(function (eventType) {
                var dashboardEventHandler = {
                    eval: function (eT) { return eT.type === eventType; },
                    handler: function (event) {
                        if (event.correlationId === correlationId) {
                            unregisterHandlers();
                            eventHandlers[eventType](event);
                        }
                    },
                };
                return dashboardEventHandler;
            })
            : [];
        dashboardEventHandlers.forEach(function (handler) {
            registerHandler(handler);
        });
        function unregisterHandlers() {
            dashboardEventHandlers.forEach(function (handler) {
                unregisterHandler(handler);
            });
        }
        onBeforeRun === null || onBeforeRun === void 0 ? void 0 : onBeforeRun(command);
        dispatch(command);
    }, []);
};
//# sourceMappingURL=useDashboardCommand.js.map